import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";

/**
 * Reusable error state display with retry functionality.
 *
 * @param {string} title - Error title
 * @param {string} message - Error description
 * @param {Function} onRetry - Retry callback (shows button if provided)
 * @param {React.ReactNode} icon - Custom icon (default: ErrorOutlineIcon)
 */
const ErrorState = ({
  title = "Er ging iets mis",
  message = "Er is een fout opgetreden bij het laden van de gegevens.",
  onRetry,
  icon,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        py: 6,
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          maxWidth: 440,
          textAlign: "center",
          borderRadius: 3,
          border: "1px solid #fecaca",
          backgroundColor: "#fef2f2",
        }}
      >
        {icon || (
          <ErrorOutlineIcon
            sx={{ fontSize: 48, color: "#ef4444", mb: 1.5 }}
          />
        )}
        <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: onRetry ? 3 : 0 }}
        >
          {message}
        </Typography>
        {onRetry && (
          <Button
            variant="contained"
            size="small"
            startIcon={<RefreshIcon />}
            onClick={onRetry}
            sx={{
              backgroundColor: "#6366f1",
              "&:hover": { backgroundColor: "#4f46e5" },
              borderRadius: 2,
              textTransform: "none",
            }}
          >
            Opnieuw proberen
          </Button>
        )}
      </Paper>
    </Box>
  );
};

export default ErrorState;
